import React, { Component } from 'react';
// import ReactTable from "react-table"
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import cssu
import DataTable from 'react-data-table-component';


class HealthSystemAdmin extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAdminApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        this.state = {
            language: null,
            savingData: false,
            data: [
                {
                    id: '',
                    answer: '',
                    originalQuestionId: '',
                    // categoryTags: '',
                    autoTranslate: '',
                    alias: '',
                }
            ],
            pageNum: null,
            faqid: '',
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            paginationValue: 10,
            dummyUUID: "00000000-0000-0000-0000-000000000000",
            searchTerm: "",
            isLoading: true,
            noMatchingData: false,

        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    NotifyFailToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addRow = (data) => {
        var addController = this;
        addController.state.paginationValue = addController.state.paginationValue + 5;
        if (addController.state.pageNum != 0) {
            addController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            answer: '',
            autoTranslate: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true,
            noMatchingData: false
        })
    }

    addAdminApi = (props, e) => {

        if (this.state.savingData) {
            return;
        }

        this.setState({ savingData: true })

        var thisController = this;
        var targetId = thisController.props.location.state.healthSystemId;
        var adminName = document.getElementById("adminName" + props.id).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + props.id).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + props.id).innerText.trim();
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
        );
        //new RegExp(/^(?=.*\d).+$/);
        // var emailpattern = new RegExp(/[a-zA-Z][a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/);
        var emailpattern = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        // var namePattern = new RegExp(/^[^\d]+$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);

        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.setState({ savingData: false });
            thisController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(adminName)) {
            thisController.setState({ savingData: false });
            thisController.notifyImproperName();
        } else if (!emailpattern.test(adminEmailId)) {
            thisController.setState({ savingData: false });
            thisController.notifyImproperEmailId();
        } else if (!contactNumberPattern.test(adminContactNumber)) {
            thisController.setState({ savingData: false });
            thisController.notifyImproperContactNumber();
        } else if (targetId == "") {
            thisController.setState({ savingData: false });
            thisController.NotifyFailToLoad();
        }
        else {

            $.ajax({
                url: "/my-jeeva-api/provider-admin",

                method: 'POST',
                data:
                {
                    role: "HEALTHSYSTEM_ADMIN",
                    userEmailId: document.getElementById("adminEmailId" + props.id).innerText.trim(),
                    userName: document.getElementById("adminName" + props.id).innerText.trim(),
                    userPhoneNumber: document.getElementById("adminContactNumber" + props.id).innerText.trim(),
                    healthSystemId: targetId,
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
                success: function (res) {
                    if (res.success === true) {

                        if (res.result == "done") {
                            thisController.notifyAdded();
                            thisController.state.disabled = false;
                            thisController.fetchHeathSystemAdminApi();
                        } else {
                            thisController.notifyExistingUser(res.result);
                            thisController.state.disabled = false;
                        }
                    } else {
                        thisController.NotifyFailToLoad();
                        thisController.state.disabled = false;

                    }
                    thisController.state.savingData = false;
                    thisController.setState(thisController.state);
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }

    }

    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Health System Admin detail has been added successfully</b>, {
            position: "top-center",

        });

    }


    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no Health System Admin present. </p>
        </div>
    );

    notifyExistingUser() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
            This user already exists</b>, {
            position: "top-center",

        });

    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(props.id);
    }
    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    updateApi(props, e) {
        var adminName = document.getElementById("adminName" + props.id).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + props.id).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + props.id).innerText.trim();
        var thisController = this
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
        );
        // var emailpattern = new RegExp(/[a-zA-Z][a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/);
        var emailpattern = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        // var namePattern = new RegExp(/^([a-zA-Z\s])*$/);
        // var namePattern = new RegExp(/^[^\d]+$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);

        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        } else if (!emailpattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        } else if (!contactNumberPattern.test(adminContactNumber)) {
            thisController.notifyImproperContactNumber();
        } else {
            var saveData = {
                id: props.id,
                healthSystemId: thisController.props.location.state.healthSystemId,
                userRole: "HEALTHSYSTEM_ADMIN",
                userEmailId: document.getElementById("adminEmailId" + props.id).innerText.trim(),
                userName: document.getElementById("adminName" + props.id).innerText.trim(),
                userPhoneNumber: document.getElementById("adminContactNumber" + props.id).innerText.trim(),
                procedureId: this.state.dummyUUID,
                hospitalId: this.state.dummyUUID,
                serviceLineId: this.state.dummyUUID,
            }

            $.ajax({
                url: "/my-jeeva-api/provider",

                method: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },

                success: function (res) {


                    if (res.success === true) {
                        if (res.result == "done") {
                            thisController.state.editedId = "-1";
                            thisController.notifyUpdated();
                            thisController.state.disabled = false;
                            thisController.fetchHeathSystemAdminApi();
                        } else {
                            thisController.notifyExistingUser(res.result);
                            thisController.state.disabled = false;
                        }
                    } else {
                        thisController.NotifyFailToLoad();
                        thisController.state.disabled = false;
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }
    }

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Health System Admin details has been updated successfully</b>, {
            position: "top-center",

        });
    }
    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }
    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    validateCells(answer) {
        if ((answer == "")) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    notifyImproperEmailId() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid email id</b>, {
            position: "top-center"
        });

    }
    notifyImproperContactNumber() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid contact number</b>, {
            position: "top-center"
        });
    }
    deleteAdminApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            var deleteData = {
                id: props.id,
                emailId: props.userEmailId,
                userRole: 'HEALTHSYSTEM_ADMIN',
                healthSystemId: deleteApiViewController.props.location.state.healthSystemId,
            }
            $.ajax({
                url: "/my-jeeva-api/delete-user",

                method: 'POST',
                data: JSON.stringify(deleteData),
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(props.id, 1);
                        deleteConstructorVariables.notifyMsgDeleteSuccess();
                        deleteConstructorVariables.fetchHeathSystemAdminApi();

                    } else {
                        if (res.result != "") {
                            deleteConstructorVariables.notifyFailToDelete(res.result);
                        }
                        else {
                            deleteConstructorVariables.NotifyFailToLoad();
                        }
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            });
        }
    }

    notifyMsgDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Health System Admin detail has been deleted successfully</b>, {
            position: "top-center"
        });
    }

    notifyFailToDelete(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    // refreshData = (id) => {
    //     var refreshContent = this
    //     refreshContent = this.state.editedId = id;
    //     this.fetchHeathSystemAdminApi()
    //     this.setState({ disabled: false })
    // }

    refreshData = (id) => {
        this.setState({
            editedId: id,
            disabled: false,
            isLoading: true,
            noMatchingData: false,
            data: [],
            searchTerm: "",
        });
        this.fetchHeathSystemAdminApi();
    };

    fetchHeathSystemAdminApi = () => {
        var thisController = this;
        var healthSystemId = thisController.props.location.state.healthSystemId;
        if (healthSystemId == "") {
            healthSystemId = thisController.state.dummyUUID;
        }
        $.ajax({
            url: "/my-jeeva-api/provider",

            method: 'GET',
            data: {
                healthSystemId: healthSystemId,
                role: 'HEALTHSYSTEM_ADMIN',
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    thisController.setState({
                        data: res.result,
                        isLoading: false,
                        noMatchingData: false,
                        disabled: false
                    })
                }
                // else {
                //     thisController.NotifyFailToLoad();
                // }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/my-jeeva/login";
                }
            }
        });
    }

    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt",
            state: {
                goBackToFaq: true,
                pageNum: pageNum
            }
        });
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchHeathSystemAdminApi();
        }, 300);
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.userName} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteAdminApi(props)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };


    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        if (event.target.value == "") {
            thisController.state.noMatchingData = false;
            thisController.setState(thisController.state);
            thisController.fetchHeathSystemAdminApi();

        } else {
            var healthSystemId = thisController.props.location.state.healthSystemId;
            if (healthSystemId == "") {
                healthSystemId = thisController.state.dummyUUID;
            }
            thisController.setState(thisController.state);

            $.ajax({
                url: "/my-jeeva-api//search-providers-data",
                method: "GET",
                data: {
                    searchTerm: thisController.state.searchTerm,
                    healthSystemId: healthSystemId,
                    role: 'HEALTHSYSTEM_ADMIN',
                },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                },

                success: function (res) {
                    if (res.success === true) {
                        if (res.result.length > 0) {
                            thisController.state.data = [];
                            thisController.state.noMatchingData = false;
                            thisController.setState(thisController.state);
                            thisController.state.data = res.result;
                            thisController.state.isLoading = false;
                            thisController.setState(thisController.state);
                        } else {
                            thisController.state.noMatchingData = true;
                            thisController.state.isLoading = false;
                            thisController.setState(thisController.state);
                        }
                    }
                },
                error: function (xhr) {

                },
            });
        }
    };

    clearSearchData = () => {
        var thisController = this;
        thisController.setState({ searchTerm: "" }, () => {
            thisController.fetchHeathSystemAdminApi();
        });
    }

    render() {
        const { data } = this.state
        const columns = [

            {
                name: <b style={{ fontSize: '16px' }}> Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userName'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{
                            height: '5vh',
                            display: `flex`,
                            alignItems: `center`,
                            background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px',
                            lineHeight: "3rem"
                        }}
                        id={"adminName" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false
                        }
                        suppressContentEditableWarning > {props.userName}

                    </div >)
            },
            {
                name: <b style={{ fontSize: '16px' }}> Email ID</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userEmailId'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', display: `flex`, alignItems: `center`, background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px', lineHeight: "3rem" }}
                        id={"adminEmailId" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.userEmailId}

                    </div>)
            },
            {
                name: <b style={{ fontSize: '16px' }}> Contact Number</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userPhoneNumber'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', display: `flex`, alignItems: `center`, background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px', lineHeight: "3rem" }}
                        id={"adminContactNumber" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.userPhoneNumber}

                    </div>)
            },

            {
                name: <b style={{ fontSize: '16px' }}>Actions</b>,
                width: "200px",
                selector: (props) => (
                    <div id="action">
                        <button
                            style={{
                                backgroundColor: "#ffffff", border: "none"
                            }}>
                            <img className="img-responsive"
                                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                // title={(props.id == "") ||
                                //     (this.state.data[props.id].id == this.state.editedId) ? 'Save' : 'Edit'}

                                src={(props.id == "") ?
                                    this.saveImageSrc : ((props.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ?
                                        this.addAdminApi(props, e) :
                                        (props.id == this.state.editedId) ?
                                            this.updateApi(props, e) :
                                            this.makeCelleditable(props, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.id) === '' ?
                                    this.fetchHeathSystemAdminApi() :
                                    this.openDeletePopUp(props)}
                            // this.setState({
                            //     hideDeletePopup: true, deletePropIndex: props.id,
                            //     propsId: props
                            // })}
                            />
                        </button>

                    </div>
                ),

            },

        ]
        return (
            <div style={{ background: "#F9F9FB" }} id='healthSystemAddAdminTab'>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div style={{ marginLeft: "-27vw" }}>
                                <h6 style={{ color: '#282a65', textAlign: 'center', marginTop: '20px' }}>
                                    Health System Admin</h6>
                                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
                            </div>
                            <div style={{ marginLeft: "50vw", marginTop: "1vh" }}>
                                <input
                                    type="text"
                                    style={{
                                        width: "10vw",
                                        border: "1px solid #777676",
                                        borderRadius: "3px",
                                        padding: "10px",
                                        height: "0.6vw",
                                        paddingRight: "2rem",
                                    }}
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    placeholder="Search ..."
                                />
                                {this.state.searchTerm && (
                                    <span
                                        onClick={() => this.clearSearchData()}
                                        style={{
                                            // position: "absolute",
                                            right: "8px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#777676",
                                            fontSize: "1.2rem",
                                            fontWeight: "bold",
                                            lineHeight: 1,
                                            userSelect: "none",
                                            marginLeft: "-1vw"
                                        }}
                                    >
                                        ×
                                    </span>
                                )}
                            </div>
                            {/* Add button */}
                            <div style={{ marginLeft: "3vw" }}>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    {/* style={{ width: '45px',margin: '5px' }}>Refresh */}
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* left Menu start here*/}
                    {/* Content Header (Page header) */}
                    {/* /.content-header */}
                    {/* Custom Tabs */}
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    <div className="card">
                                        {this.state.isLoading && (
                                            <div style={{ padding: '20px', textAlign: 'center' }}>
                                                <p>Loading ...</p>
                                            </div>
                                        )}
                                        {!this.state.isLoading && this.state.data.length === 0 && !this.state.noMatchingData && (
                                            <div style={{ padding: '20px', textAlign: 'center' }}>
                                                <p>There are no healthSystem admin present.</p>
                                            </div>
                                        )}
                                        {(!this.state.isLoading && this.state.data.length > 0 && !this.state.noMatchingData) && (
                                            < DataTable
                                                data={this.state.data}
                                                columns={columns}
                                                //pagination={this.state.pageNum}
                                                defaultSortFieldName
                                                fixedHeaderScrollHeight="400px"
                                                pagination={this.state.paginationValue}
                                                noDataComponent={<this.CustomNoDataComponent />}

                                            // defaultPageSize={10}
                                            // pageSizeOptions={[5, 10, 15]}
                                            // onPageChange={this.onPageChange}
                                            // page={this.state.pageNum}
                                            />)}
                                        {this.state.noMatchingData &&
                                            <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                                <p>No matching options found ...</p>
                                            </div>
                                        }
                                    </div>
                                    <ToastContainer className="Toast-at-center" />

                                    {/*Dialog Component For Deletion Confirmation*/}
                                    {/* <DialogComponent width='400px' animationSettings={this.settings}
                                        header='Health System Admin' showCloseIcon={true} buttons={this.buttons}
                                        ref={dialog => this.dialogInstance = dialog} target='#healthSystemAddAdminTab'
                                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                            content="" />&nbsp;Do you want to delete this Health System Admin?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default HealthSystemAdmin;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/HealthSystemAdmin.js